import Events from '@/hooks/events';
import actions from '../constants';

export default {
  useFetchDatasetMarkdown: (category, { code }) => Events.useDispatchByCode(
    actions.FETCH_DATASET_MARKDOWN,
    category,
    code,
  ),
};
